import { Injectable, OnDestroy } from '@angular/core';
import { SubjectTypeService } from './subject-type.service';
import { DefaultDataService } from './default-data.service';
import { Subject } from '../models/subject';
import { MessageBoxComponent, MessageBoxParameters, MessageBoxType } from 'app/components/messageBox/messageBox.component';
import { MatDialog } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';
import { Observable, map, of, switchMap, take, tap } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MessageService } from './messages/message.service';

@AutoUnsubscribe()
@Injectable({
  providedIn: 'root'
})
export class IntegrationsService implements OnDestroy {

  public integrationsList: IntegrationItem[] = [];

  resourceUrl: string = "api/integrations/";
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private defaultData: DefaultDataService,
    private subjectTypeService: SubjectTypeService,
    private dialog: MatDialog,
    private http: HttpClient,
    private messageService: MessageService,
  ) {
  }

  ngOnDestroy(): void {
  }

  getIntegrations(): IntegrationItem[] {
    var integrationsList: IntegrationItem[] = [];

    if (this.defaultData.dvlaSettings.dvlaEnabled == true && this.defaultData.dvlaSettings?.dvlaAPIKey?.length > 0) {
      integrationsList.push(new IntegrationItem(
        {
          name: "DVLA",
          subjectTypeId: this.defaultData.dvlaSettings.dvlaSubjectType,
          label: "Vehicle Registration Number",
          hint: "Please enter a full registration number with no spaces",
          url: "dvla/{inputField}",
          subjectTypeName: this.subjectTypeService.getByIdFromCache(this.defaultData.dvlaSettings.dvlaSubjectType).name,
        }));
    }

    // Add other subject creation integrations here like Postcode Lookup

    return integrationsList;
  }

  CheckForIntegration(subject: Subject): Observable<IntegrationResult> {
    var integrationsList = this.getIntegrations();
    var integrationsFound = integrationsList.filter(i => i.subjectTypeId == subject?.subjectTypeId);
    if (integrationsFound && integrationsFound.length > 0) {

      // Ask for label field 
      const info = new MessageBoxParameters(
        `Add a new ${integrationsFound[0].subjectTypeName.toLowerCase()} using the ${integrationsFound[0].name} integration?`,
        `New ${integrationsFound[0].subjectTypeName}`,
        MessageBoxType.YesNoWithInput
      );
      info.inputLabel = integrationsFound[0].label;
      info.inputHint = integrationsFound[0].hint;
      return this.dialog.open(MessageBoxComponent, { data: info }).afterClosed().pipe(
        switchMap(result => {
          // use integration API to get data all mapped into subject
          if (result === 'yes' && info.inputValue && info.inputValue?.length > 0) {
            return this.http.get<string>(this.resourceUrl + integrationsFound[0].url.replace('{inputField}', info.inputValue), this.httpOptions)
              .pipe(take(1),  map(e => {
                console.log(e);
                var result = new IntegrationResult();
                result.jsonResponse=e;
                result.integrationUsed=integrationsFound[0];
                result.success=true;
                return result;
              }));
          }
          else
            return of(null);
        }));
    }
    else
      return of(null);
  }
}

export class IntegrationResult
{
  success: boolean = false;
  integrationUsed:IntegrationItem =null;
  jsonResponse:string="";
}

export class IntegrationItem {
  name: string = '';
  subjectTypeId: number = -1;
  label: string = '';
  hint: string = '';
  url: string = '';
  subjectTypeName: string = '';

  constructor(d: any = null) {
    if (d) {
      this.name = d.name;
      this.subjectTypeId = d.subjectTypeId;
      this.label = d.label;
      this.hint = d.hint;
      this.subjectTypeName = d.subjectTypeName;
      this.url = d.url;
    }
  }

}